import React from 'react';
import { Link } from 'react-router-dom';

const Impressum = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-rose-50 to-white" data-testid="impressum-page">
      <div className="container mx-auto px-4 py-12 max-w-3xl">
        <Link to="/" className="text-rose-600 hover:text-rose-700 text-sm font-semibold" data-testid="impressum-back-link">
          ← Zurück zur Startseite / Back to Home
        </Link>

        <h1 className="text-4xl font-serif text-rose-900 mt-6 mb-2">Impressum</h1>
        <p className="text-sm text-gray-500 mb-10">Angaben gemäß § 5 TMG · Last updated: February 2026</p>

        {/* German version (legally required) */}
        <section className="space-y-6 text-gray-800">
          <div>
            <h2 className="text-xl font-semibold text-rose-800 mb-2">Anbieterin</h2>
            <p className="leading-relaxed">
              Esther Ewebe<br />
              Hauptstraße 3<br />
              86922 Eresing<br />
              Deutschland
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-rose-800 mb-2">Kontakt</h2>
            <p className="leading-relaxed">
              Telefon: <a href="tel:+491622541659" className="text-rose-600 hover:underline">+49 162 254 1659</a><br />
              E-Mail: <a href="mailto:info@herenterprisehub.com" className="text-rose-600 hover:underline">info@herenterprisehub.com</a>
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-rose-800 mb-2">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <p className="leading-relaxed">
              Esther Ewebe<br />
              Hauptstraße 3<br />
              86922 Eresing<br />
              Deutschland
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-rose-800 mb-2">Umsatzsteuer-Identifikationsnummer</h2>
            <p className="leading-relaxed text-gray-700">
              Kleinunternehmerin gemäß § 19 UStG, keine Umsatzsteuer-ID erforderlich.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-rose-800 mb-2">EU-Streitschlichtung</h2>
            <p className="leading-relaxed">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-rose-600 hover:underline">
                https://ec.europa.eu/consumers/odr/
              </a>.
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-rose-800 mb-2">Verbraucher­streit­beilegung / Universal­schlichtungs­stelle</h2>
            <p className="leading-relaxed">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-rose-800 mb-2">Haftung für Inhalte</h2>
            <p className="leading-relaxed text-sm text-gray-700">
              Als Diensteanbieterin bin ich gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
              Nach §§ 8 bis 10 TMG bin ich als Diensteanbieterin jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen
              oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
              Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
              Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-rose-800 mb-2">Haftung für Links</h2>
            <p className="leading-relaxed text-sm text-gray-700">
              Mein Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte ich keinen Einfluss habe.
              Deshalb kann ich für diese fremden Inhalte auch keine Gewähr übernehmen.
              Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-rose-800 mb-2">Urheberrecht</h2>
            <p className="leading-relaxed text-sm text-gray-700">
              Die durch die Seitenbetreiberin erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.
              Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen
              der schriftlichen Zustimmung der jeweiligen Autorin bzw. Erstellerin.
            </p>
          </div>
        </section>

        {/* English summary */}
        <hr className="my-12 border-rose-200" />
        <section className="space-y-4 text-gray-700">
          <h2 className="text-2xl font-serif text-rose-900">Legal Notice (English summary)</h2>
          <p className="text-sm text-gray-600 italic">
            This is a non-binding English translation. The German version above is legally authoritative.
          </p>
          <div>
            <h3 className="font-semibold text-rose-800">Operator</h3>
            <p>Esther Ewebe<br />Hauptstraße 3, 86922 Eresing, Germany</p>
          </div>
          <div>
            <h3 className="font-semibold text-rose-800">Contact</h3>
            <p>
              Phone: +49 162 254 1659<br />
              Email: info@herenterprisehub.com
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-rose-800">Responsible for content (§ 18 Abs. 2 MStV)</h3>
            <p>Esther Ewebe (address above)</p>
          </div>
          <div>
            <h3 className="font-semibold text-rose-800">VAT</h3>
            <p>Small business operator under § 19 UStG (German Small Business Regulation). No VAT ID applicable.</p>
          </div>
          <div>
            <h3 className="font-semibold text-rose-800">EU Online Dispute Resolution</h3>
            <p>
              The European Commission provides a platform for online dispute resolution (ODR):{' '}
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-rose-600 hover:underline">
                ec.europa.eu/consumers/odr
              </a>.
            </p>
          </div>
        </section>

        <p className="text-xs text-gray-400 mt-12">
          Quelle / Source: Eigene Erstellung in Anlehnung an § 5 TMG und § 18 MStV. Bei Änderung der Rechtsform (z. B. UG/GmbH/Einzelunternehmen mit Gewerbeanmeldung), bitte Impressum aktualisieren.
        </p>
      </div>
    </div>
  );
};

export default Impressum;
